import { processQuery } from './BaseDataSources';
import { ISeller } from '@/Interfaces';
import { AjaxHelper, IPaginatedList, IReadOptions, Source } from '@samc/common';

export class EligibleTargetDealBuyerSource extends Source<ISeller> {

  private _helper: AjaxHelper;
  private _query: Record<string, any> = {};

  public constructor(private loanIds: number[], sourceDealId: string | null = null, pageSize = 50) {
    super(pageSize);

    this._query = { sourceDealId };
    this._helper = new AjaxHelper('datasource/eligibletargetdealbuyers', '', '', null);
  }

  protected async getRows(options: IReadOptions, abortController: AbortController): Promise<IPaginatedList<ISeller>> {
    return await this._helper.postData<IPaginatedList<ISeller>>('',
      { loanIds: this.loanIds },
      { ...processQuery(options), ...this._query },
      { signal: abortController.signal });
  }
}